import { Component } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router'
import { WorkflowService } from '../services/workflow.service';
@Component({
  templateUrl: './template/claimProcess.component.html',
  styles: [`
    em {float:right; color:#E05C65; padding-left:10px;}
    .error input {background-color:#E3C3C5;}
    .error ::-webkit-input-placeholder { color: #999; }
    .error :-moz-placeholder { color: #999; }
    .error ::-moz-placeholder {color: #999; }
    .error :ms-input-placeholder { color: #999; }
    
  `]
})
export class ClaimProcessComponent {
  public signUpForm: UntypedFormGroup;
  public policyAccepted: boolean;
  constructor(private fb: UntypedFormBuilder, private router: Router, private workflowService: WorkflowService) {
    this.signUpForm = fb.group({
      cb: [false, Validators.requiredTrue]
    });
  }
  doLogin() {
    this.policyAccepted = this.workflowService.setWguPolicyAcknowledge();
    // console.log("ClaimProcess policy? " + this.policyAccepted)
    this.router.navigate(['identityiq/external/loginClaimProcess']);
  }

}
